export default __webpack_public_path__ + "static/media/team3.81750413.jpg";